/* eslint-disable camelcase, react/jsx-pascal-case */
import SelectBox_CreateNew from './selectBox_CreateNew';

export default SelectBox_CreateNew;
